module.exports = __webpack_public_path__ + "img/lodash.21b06f95.png";